import * as React from 'react';

import { ErrorBoundary } from 'bernie-view';
import { RouteStore } from 'bernie-core';

import { HotelViewModel } from 'models';

import { BreakfastAndWifiDisclaimer } from './breakfast-wifi-disclaimer';
import { Messaging } from 'components/common/messaging';
import { SearchResultsReviews } from './search-results-reviews';

interface ListingCommonSectionProps {
  model: HotelViewModel;
  routeStore: RouteStore;
  routeStoreGoBack: () => void;
}

export const ListingCommonSection: React.FC<ListingCommonSectionProps> = ({ model, routeStore, routeStoreGoBack }) => {
  const { disclaimerDialog, primaryCardMessages, primaryCardMessagingModel, hotelId } = model;

  return (
    <>
      <ErrorBoundary label="hotel.search.listing.messaging">
        <Messaging
          className="listing__messaging uitk-grid uitk-type-300"
          primaryMessaging={primaryCardMessagingModel}
          primaryMessagingList={primaryCardMessages}
        />
      </ErrorBoundary>
      <BreakfastAndWifiDisclaimer
        disclaimerDialog={disclaimerDialog}
        handleBack={routeStoreGoBack}
        hotelId={hotelId}
        routeStore={routeStore}
      />
      <ErrorBoundary label="hotel.search.listing.reviews">
        <SearchResultsReviews className="listing__reviews all-t-margin-two" />
      </ErrorBoundary>
    </>
  );
};
